/**
 * @file   首页
 * @create macaiqi 2021/07/27
 * @update
 */
// import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link,NavLink, useLocation } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import Slider from '@ant-design/react-slick';
import { getHome,getRelationConfig,queryGeoPlaceList } from '../../../shared/api'
import { Picture } from '@portal-site/components';
import cls from 'classnames';
import './index.scss'
import leftArrow from '@/assets/images/desktop/ahhpjz/left_arrow.png';
import rightArrow from '@/assets/images/desktop/ahhpjz/right_arrow.png';
import Default from '@/assets/images/desktop/common/default.jpg';
import { get as getProjection, transform } from 'ol/proj.js';
import View from 'ol/View';
import OlMap from 'ol/Map';
import { defaults as DefaultControl } from 'ol/control';
import { defaults as DefaultInteraction } from 'ol/interaction';
import Overlay from 'ol/Overlay';
import {Vector as VectorLayer} from 'ol/layer';
import {Vector as VectorSource} from 'ol/source';
import { Style, Text, Icon, Fill, Circle } from 'ol/style';
import olms from 'ol-mapbox-style';
import 'ol/ol.css';
const pre = window.ENV_IMG_PREURL_SRC;
const pre1 = window.ENV_IMG_PREURL;

// 头部：徽派三绝、徽派三雕
const Head = ({records,selectedIndex,toggle,showData,nextGroup}) => {
  return (
    <div className='head'>
      {records?.map((item, index) => {
        return (
          <div className={cls('head-item',{active:selectedIndex == index})} style={{backgroundImage:'url('+pre1+item.bgImg+')'}} key={index}>
            <div className='item-center'>
              <Picture source={item.titleImg} className="titleImg" />
              <p className='desc'>{item.desc}</p>
              <div className='instance-list'>
                {showData?.map((instance, index1) => {
                  return (
                    <Link to={`/Subject/null/${instance.instanceId}`} target='_blank' className="instance-item" key={index1}>
                      <div className='css-bvybze portal-picture instanceImg'>
                        <img src={instance.img.indexOf('ahhpjz/pc')>-1 ? Default : pre+instance.img} alt='' />
                      </div>
                      <div className='shadow'>
                        <p className="type">{instance.conceptName}</p>
                        <p className="title">{instance.instanceName}</p>
                      </div>
                    </Link>
                  )
                })}
              </div>
              <div className={cls("nextBtn",{'sandiao':index==1})} onClick={() => {nextGroup()}}>下一组</div>
            </div>
          </div>
        )
      })}
      {
        selectedIndex > 0 && (
          <div className="toggleBtn left_arrow" onClick={() => { toggle('prev'); }}>
            <img src={leftArrow} alt="" />
          </div>
        )
      }
      {
        records && (selectedIndex < records.length - 1) && (
          <div className="toggleBtn right_arrow" onClick={() => { toggle('next'); }}>
            <img src={rightArrow} alt="" />
          </div>
        ) 
      }
    </div>
  )
}

// 时空地图、知识大数据
const Part1 = ({records}) => {
  const [map,setMap] = useState();
  useEffect(() => {
    // 地图初始化
    initMap();
  }, [])

  useEffect(() => {
    // 加载地图标注
    const params = {
      "attrVal": "",
      "conceptCodes": ["AncientBuilding"],
      "current": 1,
      "relationships": ["创建时间"],
      "size":999
    };
    queryGeoPlaceList(params).then(res => {
      if(res && res.length>0){
        res.forEach((instance) => {
          addAddressLabel(instance)
        });
      }
    })
  }, [map])

  /**
   * @description 初始化openlayer地图对象
   */
  const initMap = () => {
    const proj = getProjection('EPSG:3857');
    // 声明坐标系
    let controls = DefaultControl({
      attribution: false,
      rotate: false,
      zoom: false
    });
    const mapObj = new OlMap({
      target: document.getElementById('mapContainer'),
      view: new View({
        center: [
          13170443.391480388,
          3489526.915941662
        ],
        projection: proj,
        zoom: 11,
        maxZoom: 20,
        minZoom: 4
      }),
      controls: controls,
      interactions: DefaultInteraction({
        mouseWheelZoom: true
      })
    });
    olms(mapObj, 'data/ditu.json');
    setMap(mapObj);
  }

  // 添加地图标记
  const addAddressLabel = (addressData) => {
    let g = addressData?.geoINfo?.geo && posFromGeoPoint(addressData.geoINfo.geo);
    if (!g) return;
    let labelPositioning = 'center-bottom';
    let offset = [0, 0];
    let str = addressData.year.split('/');
    let year = parseInt(str[0],10);
    const id = addressData.instanceId+'-'+year;
    const element = document.createElement('div');
    element.innerHTML = `
             <div class="mapLabelOverlay">
                 <div class="mapDot point-flicker"></div>
                 <div class="mapLabel">
                     ${addressData.instanceName || ''}
                 </div>
             </div>
         `;
    element.id = id;
    // 每个地名标签注册点击事件，展开它对应的描述弹出框
    element.addEventListener('click', () => {
      
    });
    const overlay = new Overlay({
      id: id,
      offset: offset,
      element: element,
      stopEvent: false
    });
    map.addOverlay(overlay);
    overlay.setPosition(g);
    // 加载后设置位置，解决设置为center拖拽时会突变
    overlay.setPositioning(labelPositioning);
  }

  /**
   * @description 字符串转换成坐标点
   * @param {String} geo "GEO(xxx, xxx)"类型的字符串
   * @returns {Array} 坐标点
   */
  const posFromGeoPoint = (geo) => {
    const startIdx = geo.indexOf('(') + 1;
    const endIdx = geo.indexOf(')');
    const posStr = geo.substring(startIdx, endIdx);
    const pos = posStr.split(' ').map((s) => parseFloat(s));
    return transform(pos, 'EPSG:4326', 'EPSG:3857')
  }

  return (
    <div className='part part1'>
      <div className="center">
        <h3>{records?.title1}<Link className='linkBtn' to='/fullpage.html#firstPage' target="_blank">查看全部</Link></h3>
        {/* <Link className='map' to='/fullpage.html#firstPage' target='_blank'>
          <Picture source={records?.img} />
        </Link> */}
        <div id="mapContainer"/>
        {/* <h3>{records?.title2}</h3> */}
        <div className='bigData'>
          {records?.datas.map((item, index) => {
            return (
              <div className='bigDataItem' key={index}>
                <h3>{item.title}</h3>
                <NavLink to={item.channel} target='_blank' className='part-item'>
                  <Picture source={item.img} />
                  {/* <p className="type">{item.title}</p> */}
                </NavLink>
              </div>
            )
          })}
        </div>
      </div>
      <div className='cloud1'/>
      <div className='cloud2'/>
    </div>
  )
}

// 影像探索
const Part2 = ({records}) => {
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    centerMode: false,
    variableWidth: true,
    swipeToSlide: true,
  };
  return (
    <div className="part part2">
      <div className='center'>
        <h3>{records?.title}<Link className='linkBtn' to='/PicturelistPage' target="_blank">查看全部</Link></h3>
        <Slider {...settings}>
          {records?.datas.map((item, index) => {
            return (
              <div className="culture-item" key={index}>
                <div className="imgbox">
                  <Link to={`/PicturelistPage/${item?.instanceId}?fileInfoId=${item?.fileInfoId}&hasMark=1`} target="_blank">
                    <div className='css-bvybze portal-picture'>
                      <img src={pre+item?.showImage?.replace('300@x','600@x')} alt='' />
                    </div>
                    <div className='mask'>
                      <div className='textGroup'>
                        <p className="type">{item.conceptName}</p>
                        <p className="title">{item.insanceName}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

// 关系图谱
const Part3 = ({records}) => {
  const datas1 = records?.datas1.slice(0,4);
  const datas2 = records?.datas2.slice(0,4);
  return (
    <div className="part part3">
      <div className='center'>
        <h3>{records?.title}<Link className='linkBtn' to='/KnowledgeRetrieval' target="_blank">查看全部</Link></h3>
        <div className='gxtp'>
          {datas1?.map((item, index) => {
            return (
              <div key={index}  onClick={() => {
                window.open(`/Relation?centersearch=${item.title}`)
              }}>
                <div className='css-bvybze portal-picture img'>
                  <img src={pre+item?.showImage?.replace('300@x','600@x')} alt='' />
                </div>
                <div className='text'>
                  <p className="title">{item.title}</p>
                  <p className="desc">{item.desc}</p>
                </div>
              </div>
            )
          })}
          {datas2?.map((item, index) => {
            return (
              <div key={index}  onClick={() => {
                window.open(`/Relation?startsearch=${item.title}&endsearch=${item.title1}`);
              }}>
                <div className='css-bvybze portal-picture img'>
                  <img src={pre+item?.showImage?.replace('300@x','600@x')} alt='' />
                </div>
                <div className='text'>
                  <p className="title">{item.title+' • '+item.title1}</p>
                  <p className="desc">{item.desc}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

// 首页
const IndexPage = () => {
  const [data, setData] = useState()  // 徽州三绝、三雕 时空地图 知识大数据 影像探索模块数据
  const [relationConfig, setRelationConfig] = useState()  // 关系图谱模块数据
  const {pathname } = useLocation()
  const [records, setRecords] = useState([]); // banner部分全部数据
  const [selectedIndex, setSelectedIndex] = useState(0); // 默认显示第一组数据 徽派三绝
  const [start, setStart] = useState(0);  // banner部分：当前显示的部分的首条数据索引 0 （1-3条）
  const [showData, setShowData] = useState([]);  // banner部分：当前展示的实例数据
  useEffect(() => {
    // 获取首页数据
    getHome().then(res => {
      let homeData = res.data;
      // 顶部banner模块初始化
      setData(homeData);
      setRecords(homeData?.['01']);
      let datas = homeData?.['01'][selectedIndex];
      let currentDatas = datas?.datas.slice(start,start+3);
      setShowData(currentDatas)
    })
    // 获取底部关系图谱数据
    getRelationConfig().then(res => {
      setRelationConfig(res.data);
    })
  }, [pathname])
  // banner 切换上一个、下一个模块方法
  const toggle = (state) => {
    if(state == 'prev'){
      if(selectedIndex > 0){
        let index = selectedIndex - 1;
        setSelectedIndex(index);
        setStart(0);
        let datas = records[index];
        let currentDatas = datas?.datas.slice(0,3);
        setShowData(currentDatas);
      }
    }else{
      if(selectedIndex < records.length - 1){
        let index = selectedIndex + 1;
        setSelectedIndex(index);
        setStart(0);
        let datas = records[index];
        let currentDatas = datas?.datas.slice(0,3);
        setShowData(currentDatas);
      }
    }
  }
  // banner 获取下一组方法
  const nextGroup = () => {
    let current = start + 3;
    let datas = records[selectedIndex];
    if(current <= datas.datas.length - 1){
      setStart(current);
    }else{
      setStart(0);
      current = 0;
    }
    let currentDatas = datas?.datas.slice(current,current+3);
    setShowData(currentDatas);
  }
  return (<div className="home-page">
    <Head records={data?.['01']} selectedIndex={selectedIndex} toggle={toggle} showData={showData} nextGroup={nextGroup}/>
    <Part1 records={data?.['02']}/>
    <Part2 records={data?.['03']}/>
    <Part3 records={relationConfig}/>
    <div className='cloud3'/>
    <div className='rbBg'/>
    <div className='rbBg1'/>
  </div>)
};

export default IndexPage;
